import { createStore } from 'redux'
import { normalizeStepStatuses } from 'utils/helpers'

const stepsOrder = {
  properties: ['stepZero', 'stepOne', 'stepTwo', 'stepThree', 'multimediaStep', 'extrasStep'],
}

const initialTypes = {
  properties: {
    propertyType: null,
    propertySubtype: null,
    enterpriseType: null,
    enterpriseStatus: null,
  },
}

const initialSteps = {
  properties: {
    stepZero: 'in_progress',
    stepOne: 'not_started',
    stepTwo: 'not_started',
    stepThree: 'not_started',
    multimediaStep: 'not_started',
    extrasStep: 'not_started',
  },
}

const initialState = {
  sidebarShow: 'responsive',
  multistepForms: {
    properties: {
      data: {},
      types: initialTypes.properties,
      status: initialSteps.properties,
      saved: false,
    },
  },
  condominium: {},
  resetReason: null,
}

const changeState = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MULTISTEP_FORM_DATA': {
      const { formName, data } = action.payload
      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            ...state.multistepForms[formName],
            data: {
              ...state.multistepForms[formName]?.data,
              ...data,
            },
          },
        },
      }
    }

    case 'SET_MULTISTEP_STEP_STATUS': {
      const { formName, stepKey, status } = action.payload
      const currentStatuses = {
        ...state.multistepForms[formName]?.status,
        [stepKey]: status,
      }

      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            ...state.multistepForms[formName],
            status: normalizeStepStatuses(stepsOrder[formName], currentStatuses),
          },
        },
      }
    }

    case 'SET_MULTISTEP_FORM_TYPES': {
      const { formName, types } = action.payload
      const currentStatuses = {
        ...state.multistepForms[formName]?.status,
      }

      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            ...state.multistepForms[formName],
            types: {
              ...state.multistepForms[formName]?.types,
              ...types,
            },
            status: normalizeStepStatuses(stepsOrder[formName], currentStatuses),
          },
        },
      }
    }

    case 'RESET_MULTISTEP_FORM': {
      const { formName, preserveData } = action.payload
      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            data: { ...preserveData },
            types: initialTypes[formName],
            status: initialSteps[formName],
            saved: false,
          },
        },
      }
    }

    case 'SET_MULTISTEP_RESET_REASON': {
      return {
        ...state,
        resetReason: action.payload,
      }
    }

    case 'CLEAR_MULTISTEP_RESET_REASON': {
      return {
        ...state,
        resetReason: null,
      }
    }

    case 'SET_MULTISTEP_FORM_AMENITY_GROUPS_CONDOMINIUM': {
      const { formName, amenitiesGroupsCondominium } = action.payload
      const currentStatuses = {
        ...state.multistepForms[formName]?.status,
      }

      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            ...state.multistepForms[formName],
            amenitiesGroupsCondominium: Array.isArray(amenitiesGroupsCondominium)
              ? amenitiesGroupsCondominium
              : [],
            status: normalizeStepStatuses(stepsOrder[formName], currentStatuses),
          },
        },
      }
    }

    case 'SET_MULTISTEP_SAVED': {
      const { formName, saved } = action.payload
      return {
        ...state,
        multistepForms: {
          ...state.multistepForms,
          [formName]: {
            ...state.multistepForms[formName],
            saved,
          },
        },
      }
    }

    case 'set':
      return {
        ...state,
        sidebarShow: action.sidebarShow,
      }

    default:
      return state
  }
}

const store = createStore(changeState)
window.__REDUX_STORE__ = store
export default store
